import TalentInfoCell from './TalentInfoCell';

export default TalentInfoCell;
